import { ReactElement } from "react";
import { AiOutlineHome } from "react-icons/ai";
import { BsFolder2Open } from 'react-icons/bs';
import { GoOrganization } from "react-icons/go";
import { FaAlignCenter } from "react-icons/fa";
import { PiHandCoinsBold, PiHandCoinsFill } from "react-icons/pi";

export type SidebarItem = {
  title: string;
  path: string;
  icon: ReactElement;
  cName: string;
  roles?: string[];
  dynamicSubNav?: boolean;
};

export type SidebarGroup = {
  title: string;
  path: string;
  icon: ReactElement;
  cName: string;
  roles?: string[];
  subNav?: SidebarItem[];
};

type SidebarElement = SidebarItem | SidebarGroup;


export const buildSidebarData = (): SidebarElement[] => [
  // global dashboard
  {
    title: "Global Dashboard",
    path: "#",
    icon: <AiOutlineHome />,
    cName: "sub-nav-text",
    roles: ["Admin"],
    subNav: [
      {
        title: "Executive Summary",
        path: "/dashboard/executive-summary",
        icon: <FaAlignCenter />,
        cName: "sub-nav-text",
        roles: ["admin"],
      },
      {
        title: "Carbon Lifecycle",
        path: "/dashboard/carbon-lifecycle",
        icon: <FaAlignCenter />,
        cName: "sub-nav-text",
        roles: ["admin"],
      },
    ],
  },
  // carbon masters
  {
    title: "Carbon Masters (CRUD)",
    path: "#",
    icon: <BsFolder2Open />,
    cName: "sub-nav-text",
    roles: ["Admin"],
    subNav: [
      {
        title: "Carbon Projects",
        path: "/carbon-master/carbon-project-master",
        icon: <GoOrganization />,
        cName: "sub-nav-text",
        roles: ["admin"],
      },
      {
        title: "Carbon Sources",
        path: "/carbon-master/carbon-source-master",
        icon: <GoOrganization />,
        cName: "sub-nav-text",
        roles: ["admin"],
      },
      {
        title: "Monitoring Batches",
        path: "/carbon-master/monitoring-batch",
        icon: <GoOrganization />,
        cName: "sub-nav-text",
        roles: ["admin"],
      },
      {
        title: "Verification Records",
        path: "/carbon-master/verification-record",
        icon: <GoOrganization />,
        cName: "sub-nav-text",
        roles: ["admin"],
      },
    ],
  },
  {
    title: "Transactions (Reports)",
    path: "#",
    icon: <BsFolder2Open />,
    cName: "sub-nav-text",
    roles: ["Admin"],
    subNav: [
      {
        title: "Minting Ledger",
        path: "/transactions/minting-transaction",
        icon: <GoOrganization />,
        cName: "sub-nav-text",
        roles: ["admin"],
      },
      {
        title: "Carbon Inventory",
        path: "/transactions/carbon-inventory",
        icon: <GoOrganization />,
        cName: "sub-nav-text",
        roles: ["admin"],
      },
      {
        title: "Sales Report",
        path: "/transactions/carbon-sale-transaction",
        icon: <GoOrganization />,
        cName: "sub-nav-text",
        roles: ["admin"],
      },
      {
        title: "Retirement Records",
        path: "/transactions/retirement-transaction",
        icon: <GoOrganization />,
        cName: "sub-nav-text",
        roles: ["admin"],
      },
    ],
  },
  {
    title: "Family Office",
    path: "#",
    icon: <PiHandCoinsFill />,
    cName: "sub-nav-text",
    roles: ["Admin"],
    subNav: [
      {
        title: "Investor Allocation",
        path: "/family-office/family-office-allocation",
        icon: <PiHandCoinsBold />,
        cName: "sub-nav-text",
        roles: ["admin"],
      },
    ],
  },
  {
    title: "BSRL & Compliance",
    path: "#",
    icon: <BsFolder2Open />,
    cName: "sub-nav-text",
    roles: ["Admin"],
    subNav: [
      {
        title: "Species Registry",
        path: "/brsr-compliance/species-registry",
        icon: <GoOrganization />,
        cName: "sub-nav-text",
        roles: ["admin"],
      },
      {
        title: "Method Library",
        path: "/brsr-compliance/method-library",
        icon: <GoOrganization />,
        cName: "sub-nav-text",
        roles: ["admin"],
      },
      {
        title: "Risk & Materiality",
        path: "/brsr-compliance/risk-materiality-log",
        icon: <GoOrganization />,
        cName: "sub-nav-text",
        roles: ["admin"],
      },
      {
        title: "Emissions Ledger",
        path: "/brsr-compliance/emissions-ledger",
        icon: <GoOrganization />,
        cName: "sub-nav-text",
        roles: ["admin"],
      },
      {
        title: "Audit Snapshots",
        path: "/brsr-compliance/audit-disclosure-snapshot",
        icon: <GoOrganization />,
        cName: "sub-nav-text",
        roles: ["admin"],
      },
      {
        title: "Emission Factors",
        path: "/brsr-compliance/emission-factor-master",
        icon: <GoOrganization />,
        cName: "sub-nav-text",
        roles: ["admin"],
      },
    ],
  },
];

